/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Speed_DescriptionInputs */

const en_features_speed_description = /** @type {(inputs: Features_Speed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom through easy texts at 3x speed. Slow to 0.75x for complex papers. Customize your reading speed based on what your brain needs. The voices sound great at every speed!`)
};

const es_features_speed_description = /** @type {(inputs: Features_Speed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanza rápidamente por textos fáciles a velocidad 3x. Reduce a 0.75x para artículos complejos. Personaliza tu velocidad de lectura según lo que tu cerebro necesite. ¡Las voces suenan genial a cualquier velocidad!`)
};

/**
* | output |
* | --- |
* | "Zoom through easy texts at 3x speed. Slow to 0.75x for complex papers. Customize your reading speed based on what your brain needs. The voices sound great at..." |
*
* @param {Features_Speed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_speed_description = /** @type {((inputs?: Features_Speed_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Speed_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_speed_description(inputs)
	return en_features_speed_description(inputs)
});